import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';

// Dialogs render into <body>, not where they are written.
//
// A modal authored inside the till's cart panel was painting UNDER the register
// bar: `position: sticky` makes that panel its own stacking context, so the
// overlay's z-index only ever competed with the panel's siblings, never with a
// fixed bar outside it — and a Cancel button under the bar takes the bar's
// clicks, not its own. No z-index on the overlay wins that argument; it has to
// leave the subtree. Every dialog in the app goes through here, so this holds
// wherever one is opened from: a sticky panel, a transformed card, a scroll
// container.
const Modal = ({ title, onClose, children, footer, wide }) => {
  // Escape always closes, whatever is drawn over the buttons.
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  return createPortal(
    <div className="modal-overlay" onClick={onClose}>
      <div className={`modal${wide ? ' modal-lg' : ''}`} onClick={(e) => e.stopPropagation()}>
        <div className="modal-head">
          <h3>{title}</h3>
          <button className="modal-close" onClick={onClose} aria-label="Close">×</button>
        </div>
        <div className="modal-body">{children}</div>
        {footer && <div className="modal-foot">{footer}</div>}
      </div>
    </div>,
    document.body,
  );
};

export default Modal;
